<template>
    <AuthenticatedLayout>
        <h2>Визуальное тестирование индикаторов</h2>
        <Card>
            <template #content>
                <div v-for="pair in pairs" class="mb-4">
                    <div class="text-xl mb-2">{{pair}}</div>
                    <div class="mb-1 text-blue-500"><Link :href="'/indicators/ma/'+pair+'/1m/600'">MA indicator</Link></div>
                    <div class="mb-1 text-blue-500"><Link :href="'/indicators/hll/'+pair+'/1m/600'">HLL indicator</Link></div>
                    <div class="mb-1 text-blue-500"><Link :href="'/indicators/leledc/'+pair+'/1m/600'">LELEDC indicator</Link></div>
                    <div class="mb-1 text-blue-500"><Link :href="'/indicators/mac/'+pair+'/1m/600'">MAC indicator</Link></div>
                    <div class="mb-1 text-blue-500"><Link :href="'/indicators/rs/'+pair+'/1m/600'">RS indicator</Link></div>
                    <div class="mb-1 text-blue-500"><Link :href="'/indicators/peak/'+pair+'/1m/600'">Peak indicator</Link></div>
                </div>
            </template>
        </Card>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Card from "primevue/card";
import { Link } from '@inertiajs/vue2';
export default {
    components:{
        AuthenticatedLayout, Card, Link
    },
    props:{
        pairs: Array,
    },
    data(){
        return {

        }
    },
}
</script>
